import type { FaireProductEntity } from "../../entity_types/product";

export const p_79c86ytjaz: FaireProductEntity = {
  token: "p_79c86ytjaz",
  type: "product",
  name: "Ruby-throated Hummingbird Patch",
  brandToken: "b_6i5zv0objg",
  brandName: "Bird Collective",
  imageUrl:
    "https://cdn.faire.com/fastly/c73ec94fbdcc590d08ffdbe636bd7cc043e41cabda5ac6e8aa91ad919ceb499a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/52e5682b60ccac13db6d8bb0eb5a4324ab9ce43666bbb1076e523873e24298cc.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "#40 Ruby-throated Hummingbird\n\nBold and brilliant, Ruby-throated Hummingbirds are eastern North America’s only breeding hummingbird, a dazzling sight of red and green as they buzz around flower gardens or backyard feeders in search of nectar. These tiny birds will migrate across the Gulf of Mexico in a single flight, beating their wings about 53 times a second. Most spend winters in Central America.\n",
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:29.999Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
